import { c as _c } from "react/compiler-runtime";
import { Box } from "@chakra-ui/react";
import CardHazard from "./card-hazard";
import { Hazards } from "../data/data";
import { CardContainer } from "./card-container";
import { Dispatch, SetStateAction } from "react";
import { LayerToggleObjProps } from "./address-mapper";
type HazardData = {
  softStory?: any;
  tsunami?: any;
  liquefaction?: any;
  femaRisk?: any;
};
const ReportHazards = t0 => {
  const $ = _c(11);
  const {
    addressHazardData,
    isHazardDataLoading,
    toggledStates,
    setToggledStates,
    setLayerToggleObj,
    isInDrawer: t1,
    stackDirectionResponsive: t2
  } = t0;
  const isInDrawer = t1 === undefined ? false : t1;
  const stackDirectionResponsive = t2 === undefined ? false : t2;
  const t3 = !isInDrawer;
  let t4;
  if ($[0] !== addressHazardData || $[1] !== isHazardDataLoading || $[2] !== isInDrawer || $[3] !== setLayerToggleObj || $[4] !== setToggledStates || $[5] !== toggledStates) {
    t4 = Hazards.map(hazard => <CardHazard key={hazard.id} hazard={hazard} hazardData={addressHazardData?.[hazard.name as keyof HazardData] ?? undefined} showData={hazard.name in addressHazardData ? true : false} isHazardDataLoading={isHazardDataLoading} toggledStates={toggledStates} setToggledStates={setToggledStates} setLayerToggleObj={setLayerToggleObj} fullWidth={isInDrawer} />);
    $[0] = addressHazardData;
    $[1] = isHazardDataLoading;
    $[2] = isInDrawer;
    $[3] = setLayerToggleObj;
    $[4] = setToggledStates;
    $[5] = toggledStates;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== stackDirectionResponsive || $[8] !== t3 || $[9] !== t4) {
    t5 = <Box><CardContainer padded={t3} stackDirectionResponsive={stackDirectionResponsive}>{t4}</CardContainer></Box>;
    $[7] = stackDirectionResponsive;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
export default ReportHazards;